export function validateEmail(email: string): boolean {
  const re = /\S+@\S+\.\S+/;
  return re.test(email) && !!email.length;
}

export const validatePassword = (password: string): boolean => {
  return password.length >= 8 && password.length <= 20;
};

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  const re = /^[0-9\b]+$/;
  return re.test(phoneNumber);
};

export const validateZipCode = (zip: string): boolean => {
  const re = /^[0-9\b]+$/;
  return re.test(zip);
};

export const validateWebsite = (website: string): boolean => {
  const re = /^(http|https):\/\/[^ "]+$/;
  return re.test(website);
};

export const validateName = (name: string): boolean => {
  const re = /^[a-zA-Z]+$/;
  return re.test(name);
};
